import { z } from 'zod';
import { apiClient } from '@/core/api/client';
import { ENDPOINTS } from '@/core/api/endpoints';
import { AnticipoSchema, } from '@/data/dto/anticipo';
export const anticiposApi = {
    async listar(filtros = {}) {
        const res = await apiClient.get(ENDPOINTS.anticipos, {
            params: {
                tipo: filtros.tipo,
                personaId: filtros.personaId,
                pendientes: filtros.pendientes ? 'true' : undefined,
            },
        });
        return z.object({ items: z.array(AnticipoSchema) }).parse(res.data).items;
    },
    async crear(values) {
        const res = await apiClient.post(ENDPOINTS.anticipos, {
            tipo: values.tipo,
            personaId: values.personaId,
            monto: Number(values.monto),
            fecha: values.fecha,
            observaciones: values.observaciones || null,
        });
        return AnticipoSchema.parse(res.data);
    },
    async eliminar(id) {
        await apiClient.delete(`${ENDPOINTS.anticipos}/${id}`);
    },
};
